import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  CategoriasCadastroDto,
  CategoriasCadastroSchema,
} from "./CategoriasCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import { useToast } from "src/componentes/Toast/Toast";
import {
  CategoriaAtualizar,
  CategoriaBuscarPorId,
  CategoriaIncluir,
} from "src/services/Estoque.Service";

const CategoriasCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const { showToast } = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<CategoriasCadastroDto>({
    resolver: yupResolver(CategoriasCadastroSchema),
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await CategoriaBuscarPorId(id);
          if (response.data.success) {
            const data = response.data.data;
            reset(data);
            setIncluir(false);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar Categorias",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const onSubmit = async (data: CategoriasCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    if (incluir === true) {
      CategoriaIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/estoque/produtos/categorias");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      CategoriaAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/estoque/produtos/categorias");
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return {
    loading,
    onSubmit,
    handleSubmit,
    errors,
    register,
    setValue,
  };
};
export default CategoriasCadastroCode;
